var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiTableRow from '@material-ui/core/TableRow';
/**
 * Kareo wrapped component of the Material-UI TableContainer. The prop API has been limited to props defined in TableContainerProps.
 *
 * Tables display sets of data in a way that’s easy to scan, so that users can look for patterns and insights.
 *
 * Material-UI TableContainer: [Docs](https://v4.mui.com/components/tables/), [API](https://v4.mui.com/api/table-container/)
 *
 * @storybook: [Table](http://design.kareoprod.ent/design-system/?path=/story/components-data-display-table--table-main-story)
 */
var TableRow = React.forwardRef(function (props, ref) { return (React.createElement(MuiTableRow, __assign({}, props, { ref: ref }))); });
TableRow.displayName = 'KareoTableRow';
export default TableRow;
